<div class="signup-container">
	<div class="content-wrapper">
		<ng-content></ng-content>
	</div>
</div>
